//Web server base url
export const API_BASE_URL = process.env.REACT_APP_SERVER_URL + "/api" || "/api";

export const SERVER_URL = process.env.REACT_APP_SERVER_URL || "https://api.lobees.com/";

export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL || "https://admin.lobees.com";

export const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL || "https://app.lobees.com";

// export const FRONTEND_BASE_URL = "http://localhost:4202"; // For frontend

/*=========== all Demo Data API URL start here ===========*/
export const DEMO_GET = "/demo/demoget"; // for get demo data

export const DEMO_POST = "/demo/demopost"; // for testing post data
/*=========== all Demo Data API URL end here ===========*/

// all json options url
export const ALLERGEN_OPTIONS = "data/allergen.json";
export const ALLERGIES_OPTIONS = "data/allergies.json";
export const ALLERGY_REACTION_OPTIONS = "data/allergyreaction.json";
export const ALLERGY_SEVERITIES_OPTIONS = "data/allergyseverites.json";
export const ALLERGY_TYPE_OPTIONS = "data/allergytype.json";
export const CONDITION_STATUS_OPTIONS = "data/conditonstatus.json";
export const HOSPITALS_OPTIONS = "data/hospitals.json"; // for facilities
export const MEDICAL_CONDITIONS_OPTIONS = "data/medicalconditions.json";
export const MEDICAL_TEST_CATEGORIES_OPTIONS =
  "data/medicaltestcategories.json";
export const MEDICINES_OPTIONS = "data/medicines.json"; // medicine options
export const VACCINES_OPTIONS = "data/vaccines.json"; // vaccines options
export const MEAL_TYPE_OPTIONS = "data/mealtypeoptions.json"; // meal type options
export const DIET_TYPE_OPTIONS = "data/diettypeoptions.json"; // diet type options
export const SPORTS_ACTIVITY_TYPES_OPTIONS = "data/sportsactivitytypes.json"; // sports activities
/** Json options end */

/*======= login and registration url start =======*/
export const API_LOGIN = "/auth/login"; //login url

export const API_REGISTRATION = "/auth/register"; //registration url

export const API_GET_OTP = "/auth/getotp"; //for getting otp

export const API_VALIDATE_OTP = "/auth/validateotp"; //for validating otp

export const API_UPDATE_PASSSWORD = "/auth/updatepassword"; //for update passowrd

export const API_AUTH_VALIDATE = "/auth/validateuser"; //validation url

export const API_LOGOUT = "/auth/logout"; //logout url

export const API_LOGOUT_ALL = "/auth/logout-all"; //logout from all devices

export const API_GET_SESSIONS = "/auth/sessions"; //get all active sessions
export const API_GET_TOKEN = "/auth/token"; //get current JWT for 3rd party tool use

export const API_UNSUBSCRIBE_TO_MAIL = "/message/unsubsribetomail"; //unsubscribe mail

export const API_SUBSCRIBE_TO_MAIL = "/message/subscribetomail"; //subscribe mail

export const API_REDSYS_CREATE_PAYMENT = "/redsys/pay/create-payment"; //create Redsys payment
export const API_REDSYS_SUBSCRIPTION_PAYMENT =
  "/redsys/pay/subscription-payment"; //create subscription-payment payment
/*======= login and registration url end =======*/

/*======= File upload url start =======*/
export const API_SINGLE_FILE_UPLOAD = "/upload/singleupload"; //for single file upload

export const API_MULTIPLE_FILE_UPLOAD = "/upload/multiupload"; //for multiple file upload

//get all uploads
export const API_GET_ALL_UPLOADS = "/upload/getalluploads";

//delete bulk uploads
export const API_DELETE_BULK_UPLOADS = "/upload/deletebulkuploads";
/*======= File upload url end =======*/

/*======= URL to upload Image in Text Editor start =======*/
export const URL_TEXT_EDITOR_IMAGE_UPLOAD =
  "https://dev.lobees.com/web/uploads/documents/";

export const URL_TEXT_EDITOR_IMAGE_UPLOAD_SECOND =
  "https://dev.lobees.com/web/uploads/reports/";
/*======= URL to upload Image in Text Editor end =======*/

// role url start

//add role
export const API_ADD_ROLE = "/role/createrole";

export const API_GET_ALL_ROLES = "/role/getroles"; //get app user roles

//getfilteredroles
export const API_GET_FILTERED_ROLES = "/role/getfilteredroles";

//get role details
export const API_GET_ROLE_DETAILS = "/role/getroledetails";

//update role
export const API_UPDATE_ROLE = "/role/updaterole";

// delete bulk role
export const API_DELETE_BULK_ROLE = "/role/deletebulkrole";
// role url end

//add Plan --------------------------------------
export const API_ADD_PLAN = "/plan/create";

// get all plans
export const API_GET_ALL_PLANS = "/plan/getall"; //get app user roles

//get plan details
export const API_GET_PLAN_DETAILS = "/plan/getdetails";

//update plan
export const API_UPDATE_PLAN = "/plan/update";

// category url start
//add category
export const API_ADD_CATEGORY = "/category/createcategory";

//get all Categories
export const API_GET_CATEGORIES = "/category/getcategories";

//get filtered categories
export const API_GET_FILTERED_CATEGORIES = "/category/getfilteredcategories";

//get category details
export const API_GET_CATEGORY_DETAILS = "/category/getcategorydetails";

//update category
export const API_UPDATE_CATEGORY = "/category/updatecategory";

// category url end

/* module url start */
//add module
export const API_CREATE_MODULE = "/module/createmodule";

//get modules
export const API_GET_ALL_MODULES = "/module/getallmodules";

//get filtered modules
export const API_GET_FILTERED_MODULES = "/module/getfilteredmodules";

//get module details
export const API_GET_MODULE_DETAILS = "/module/getmoduledetails";

//update module
export const API_UPDATE_MODULE = "/module/updatemodule";

//update bulk module
export const API_UPDATE_BULK_MODULE = "/module/updatebulkmodule";

//delete bulk module
export const API_DELETE_BULK_MODULE = "/module/deletebulkmodule";

/* module url end */

// module roles url start
//add module
export const API_CREATE_MODULE_ROLE = "/modulerole/createmodulerole";

//get modules
export const API_GET_ALL_MODULE_ROLE = "/modulerole/getallmoduleroles";

//get filtered modules
export const API_GET_FILTERED_MODULE_ROLE =
  "/modulerole/getfilteredmoduleroles";

//get module details
export const API_GET_MODULE_ROLE_DETAILS = "/modulerole/getmoduleroledetails";

//update module
export const API_UPDATE_MODULE_ROLE = "/modulerole/updatemodulerole";

//delete bulk module role
export const API_DELETE_BULK_MODULE_ROLE = "/modulerole/deletebulkmodulerole";

// module roles url end

//module role previlege url
//update
export const API_UPDATE_MODULE_ROLE_PREVILEGE =
  "/moduleroleprevilege/updatemoduleroleprevilege";

//get all
export const API_GET_ALL_MODULE_ROLE_PREVILEGES =
  "/moduleroleprevilege/getallmoduleroleprevilege";

//get all
export const API_GET_ALL_MODULE_ACCESS = "/moduleroleprevilege/getmoduleaccess";

/* field privilege url start */
//save/update allowed fields for a module
export const API_SAVE_FIELD_PRIVILEGE = "/fieldprivilege/savefieldprivilege";

//get allowed fields for a module
export const API_GET_FIELD_PRIVILEGE = "/fieldprivilege/getfieldprivilege";
/* field privilege url end */

/* ecosysyem url start */
//add ecosystem
export const API_ADD_ECOSYSTEM = "/ecosystem/createecosystem";

//get all ecosystem
export const API_GET_ALL_ECOSYSTEM = "/ecosystem/getecosystems";

// get ecosystem by filter
export const API_GET_FILTERED_ECOSYSTEM = "/ecosystem/getfilteredecosystem";

//get details
export const API_GET_ECOSYSTEM_DETAILS = "/ecosystem/getecosystemdetails";

//get ecosystem by slug
export const API_GET_ECOSYSTEM_BY_SLUG = "/ecosystem/getecosystembyslug";

//switch ecosystem
export const API_SWITCH_ECOSYSTEM = "/ecosystem/switchecosystem";

//update ecosystem
export const API_UPDATE_ECOSYSTEM = "/ecosystem/updateecosystem";

//deletebulkecosystem
export const API_DELETE_BULK_ECOSYSTEM = "/ecosystem/deletebulkecosystem";

/* ecosysyem url end */

/*====== chat conversation begins ======*/
//get  GPT AI ------
// -------------------------------------------------------------
export const API_CHAT_GPT_RESPONSE = "/chat/gpt"; // basic gpt

export const API_CHAT_GPT_PROMPTS = "/gptprompt/getprompts"; // gpt prompts for ecosystem

export const API_CHAT_GPT_ASSISTANT = "/chat/gpt/assistant"; // with assistant

export const API_CHAT_GPT_CV_ASSISTANT = "/chat/gpt/cvassistant"; // with CV assistant

export const API_CHAT_GPT_ASSISTANT_FILEUPLOAD = "/chat/gpt/fileassistant";

//askgpt
export const API_GET_RESPONSE_FROM_AI = "/chat/askgpt";

// ------------- GPT AI ends ------------------------------------

//get all event roles
export const API_GET_ALL_MODULE_ROLES = "/modulerole/getallmoduleroles";

/*----- tag/label url start ------*/
//create tag
export const API_CREATE_NEW_TAG = "/tag/createtag";

//get all tag
export const API_GET_ALL_TAGS = "/tag/getalltags";

//get tag details
export const API_GET_TAG_DETAILS = "/tag/gettagdetails";

//update tag
export const API_UPDATE_TAG = "/tag/updatetag";

/*----- tag/label url end ------*/

/*====== skillpoint url start ======*/
//add new skillpoint
export const API_CREATE_NEW_SKILLPOINT = "/skillpoint/addskillpoint";

//get skillpoint details
export const API_GET_SKILLPOINT_DETAILS = "/skillpoint/getskillpointdetails";

//update skillpoint
export const API_UPDATE_SKILLPOINT = "/skillpoint/updateskillpoint";

//delete skillpoint
export const API_DELETE_SKILLPOINT = "/skillpoint/deleteskillpoint";

/*====== skillpoint url end ======*/

/*====== lead url start ======*/
//create lead
export const API_CREATE_LEAD = "/lead/createlead";

//create lead
export const API_CREATE_LEAD_BY_UPLOADED_CV = "/lead/createleadbyuploadedcv";

//purchase lead
export const API_PURCHASE_LEAD = "/lead/purchaselead";

//verifyleademails
export const API_VERIFY_LEAD_EMAILS = "/lead/verifyleademails";

//linkedin helper
export const API_LINKEDIN_HELPER = "/lead/linkedinhelper";

//get all lead
export const API_GET_ALL_LEADS = "/lead/getallleads";

//get all lead
export const API_ADV_FILTER_ALL_LEADS = "/lead/getFilteredLeads";

//getallleadoptions
export const API_GET_ALL_LEAD_OPTIONS = "/lead/getallleadoptions";

//getallecoleads
export const API_GET_ALL_ECO_LEADS = "/lead/getallecoleads";

//getleaddashboard
export const API_GET_LEAD_DASHBOARD = "/lead/getleaddashboard";

//get lead history
export const API_GET_LEAD_HISTORY = "/lead/getleadhistory";

//get lead details
export const API_GET_LEAD_DETAILS = "/lead/getleaddetails";

//update lead
export const API_UPDATE_LEAD = "/lead/updatelead";

//updatemassivelead
export const API_UPDATE_MASSIVE_LEAD = "/lead/updatemassivelead";

//delete lead
export const API_DELETE_LEAD = "/lead/deletelead";

//delete bulk lead
export const API_DELETE_BULK_LEAD = "/lead/deletebulklead";

//add/remove tag lead
export const API_ADD_REMOVE_TAG_LEAD = "/lead/addremovetaglead";

//addremovefollowerslead
export const API_ADD_REMOVE_FOLLOWERS_LEAD = "/lead/addremovefollowerslead";

export const API_SAVE_LEADS_BYCSV = "/lead/bulkupload";

export const API_SAVE_LEADS_MASSIVEUPLOAD = "/lead/massiveupload";

export const API_SAVE_QUICK_LEAD = "/lead/savemultipleleads";

//getleaddisableeligibility
export const API_GET_LEAD_DISABLE_ELIGIBILITY =
  "/lead/getleaddisableeligibility";

/*====== lead url end ======*/

// Task CSV/Excel massive upload
export const API_SAVE_TASKS_MASSIVEUPLOAD = "/project/massiveuploadtasks";

/*====== contact url start ======*/

/* search by name or email to get 
follower and member options in 
company,task,project,event,group,process,invoice etc .. */
export const API_GET_USERLIST_OPTIONS = "/contact/getuserlistforoptions";

//send connect request
export const API_SEND_REQUEST_USER = "/contact/sendinvite";

//get all contact
export const API_GET_ALL_CONTACTS = "/contact/getallcontacts";

//get all connect invites
export const API_GET_ALL_RECIEVED_INVITE = "/contact/getallrecievedinvites";

//get all send invite list
export const API_GET_ALL_SEND_INVITE = "/contact/getallsendinvites";

//accept/reject invite
export const API_ACCEPT_INVITE = "/contact/updatecontact";

//cancel/reject request
export const API_REJECT_CONTACT_REQUEST = "/contact/rejectrequest";

//searchcontact
export const API_SEARCH_CONTACT = "/contact/searchcontact";

//get all contact for availibility calendar in calendar
export const API_GET_ALL_CONTACTS_OPTIONS = "/contact/getallcontactsforoptions";

//get contact details
export const API_GET_CONTACT_DETAILS = "/contact/getcontactdetails";

//add tag
export const API_ADD_REMOVE_LABEL_CONTACT = "/contact/addtagtocontact";

//unfriend contact
export const API_UNFRIEND_CONTACT = "/contact/unfriendcontact";

//bulk unfriend contact
export const API_BULK_UNFRIEND_CONTACT = "/contact/bulkunfriend";

//get timeline
export const API_GET_CONTACT_TIMELINE = "/contact/gettimeline";

//massiveupload
export const API_SAVE_CONTACTS_MASSIVEUPLOAD = "/contact/massiveupload";

/*====== contact url end ======*/

/*====== blog url start ======*/
//create new blog
export const API_CREATE_NEW_BLOG = "/blog/createblog";

//get all blog
export const API_GET_ALL_BLOG = "/blog/getallblogs";

//getfilteredblogs
export const API_GET_FILTERED_BLOG = "/blog/getfilteredblogs";

//get blog details
export const API_GET_BLOG_DETAILS = "/blog/getblogdetails";

//update blog
export const API_UPDATE_BLOG = "/blog/updateblog";

//update bulk blog
export const API_UPDATE_BULK_BLOG = "/blog/updatebulkblog";

//delete blog
export const API_DELETE_BLOG = "/blog/deleteblog";

//delete bulk blog
export const API_DELETE_BULK_BLOG = "/blog/deletebulkblog";

//add or remove label/tag to blog
export const API_ADD_REMOVE_TAG_BLOG = "/blog/addremovetagblog";

/*====== blog url end ======*/

/*====== success story url start ======*/
//get all company list
export const API_GET_ALL_COMPANY_LIST = "/company/getcompanyselectlist";

//getfilteredcompanylist
export const API_GET_FILTERED_COMPANY_LIST = "/company/getfilteredcompanylist";

//add new success story
export const API_ADD_NEW_SUCCESS_STORY = "/successstories/createsuccessstories";

//get all success story
export const API_GET_ALL_SUCCESS_STORIES =
  "/successstories/getallsuccessstories";

//get success story details
export const API_GET_SUCCESS_STORY_DETAILS =
  "/successstories/getsuccessstoriesdetails";

//update success story
export const API_UPDATE_SUCCESS_STORY = "/successstories/updatesuccessstories";

//delete success story
export const API_DELETE_SUCCESS_STORY = "/successstories/deletesuccessstories";

//add/remove label
export const API_ADD_REMOVE_TAG_SUCCESS_STORY =
  "/successstories/addremovetagsuccessstories";

/*====== success story url end ======*/

/*===== experts/appuser url start ======*/
//search user for add member in event,group
export const API_GET_USERLIST = "/account/getuserlist";

//getfilteredusers
export const API_GET_FILTERED_USERS = "/account/getfilteredusers";

//add new user
export const API_ADD_NEW_USER = "/account/addnewuser";

//get all app users
export const API_GET_APP_USERS = "/account/getallappusers";

//add/remove tag to app user
export const API_ADD_REMOVE_TAG_APP_USER = "/account/addtagtouser";

//get app user details
export const API_GET_USER_DETAILS = "/account/userdetails";

//update app user
export const API_UPDATE_APP_USER = "/account/updateuser";

//bulk update user
export const API_BULK_UPDATE_USER = "/account/updatebulkuser";

//get calendar followers
export const API_GET_CALENDAR_FOLLOWERS = "/account/getcalendarfollowers";

//manage calendar followers (add/remove)
export const API_MANAGE_CALENDAR_FOLLOWERS = "/account/managecalendarfollowers";

//getuserdisableeligibility
export const API_GET_USER_DISABLE_ELIGIBILITY =
  "/account/getuserdisableeligibility";

//deleteaccountbulk
export const API_DELETE_BULK_USER = "/account/deleteaccountbulk";

//changeuserpassword
export const API_CHANGE_USER_PASSWORD = "/account/changeuserpassword";

//add new day availibility
export const API_ADD_NEW_DAYS_AVAILIBILITY = "/account/adddayavailibility";

//save time availibility by day
export const API_ADD_TIME_AVAILIBILITY_OF_DAY = "/account/savetimeavailibility";

//getallavailibility
export const API_GET_ALL_DAYS_AVAILIBILITY = "/account/getallavailibility";

//getavailibilitydetails
export const API_GET_DAYS_AVAILIBILITY_DETAILS =
  "/account/getavailibilitydetails";

//updatetimeavailibility
export const API_UPDATE_TIME_AVAILIBILITY = "/account/updatetimeavailibility";

//deletetimeavailibility
export const API_DELETE_TIME_AVAILIBILITY = "/account/deletetimeavailibility";

/*===== experts/appuser url end ======*/

/*====== event url start ======*/

//create event
export const API_CREATE_EVENT = "/event/createevent";

//get all event
export const API_GET_ALL_EVENTS = "/event/getallevents";

//get filteredevents
export const API_GET_FILTERED_EVENTS = "/event/getfilteredevents";

//get parnet events
export const API_GET_PARENT_EVENTS = "/event/getparentevents";

//get event list for select
export const API_GET_EVENT_LIST_OPTIONS = "/event/geteventlistforoptions";

//get event details
export const API_GET_EVENT_DETAILS = "/event/geteventdetails";

//geteventmemberdetailsbyquery
export const API_GET_EVENT_MEMBER_DETAILS_BY_QUERY =
  "/event/getmemberdetailsbyquery";

//update event
export const API_UPDATE_EVENT = "/event/updateevent";

//update bulk event
export const API_UPDATE_BULK_EVENT = "/event/updatebulkevent";

//delete event
export const API_DELETE_EVENT = "/event/deleteevent";

//delete mass events
export const API_DELETE_EVENTS = "/event/deletemassevents";

//join event
export const API_JOIN_EVENT = "/event/joinevent";

//add/remove tag
export const API_ADD_REMOVE_TAG_EVENT = "/event/addremovetagevent";

//add member in event
export const API_ADD_NEW_EVENT_MEMBER = "/event/addnewmember";

//add sponsor
export const API_ADD_NEW_EVENT_COMPANY = "/event/addnewcompany";

//get all event member
export const API_GET_ALL_EVENT_MEMBER = "/event/getallmembers";

//getallsponsors
export const API_GET_ALL_EVENT_PARTNERS = "/event/getallsponsors";

//get member details
export const API_GET_EVENT_MEMBER_DETAILS = "/event/getmemberdetails";

//update event member
export const API_UPDATE_EVENT_MEMBER = "/event/updateeventmember";

//add/remove tag to event memeber
export const API_ADD_REMOVE_TAG_EVENT_MEMBER = "/event/addremovetageventmember";

//add gallery images
export const API_ADD_EVENT_GALLERY_IMAGES = "/event/addgalleryimage";

//delete gallery image
export const API_DELETE_EVENT_GALLERY_IMAGE = "/event/deletegalleryimage";

//get all event options
export const API_GET_EVENT_PRODUCTS = "/event/geteventproducts";
//Add event products
export const API_ADD_EVENT_PRODUCTS = "/event/addeventproduct";
//Update event products
export const API_UPDATE_EVENT_PRODUCTS = "/event/updateeventproduct";
//get event product details
export const API_GET_EVENT_PRODUCT_DETAILS = "/event/geteventproductdetails";

//add/remove tag to event product
export const API_ADD_REMOVE_TAG_EVENT_PRODUCT = "/event/addtagtoeventproduct";

//addremovefollowersevent
export const API_ADD_REMOVE_FOLLOWERS_EVENT = "/event/addremovefollowersevent";

//event quotations
export const API_GET_ALL_QUOTATIONS = "/quotation/getquotations";
export const API_GET_FILTERED_QUOTATIONS = "/quotation/getfilteredquotations";
export const API_ADD_QUOTATION = "/quotation/createquotation";
export const API_UPDATE_QUOTATION = "/quotation/updatequotation";
export const API_DELETE_QUOTATION = "/quotation/deletequotations";
export const API_GET_QUOTATION_DETAILS = "/quotation/getquotationdetails";
export const API_ADD_REMOVE_TAG_QUOTATION = "/quotation/addremovetag";

/*====== event url end ======*/

/*===== mail template url start ======*/
//get all survey for action link
export const API_GET_SURVEY_LIST = "/messagetemplate/getallsurveylist";

//create template
export const API_CREATE_MAIL_TEMPLATE = "/messagetemplate/create";

//get all template
export const API_GET_ALL_MAIL_TEMPLATES = "/messagetemplate/getall";

//getlist for select
export const API_GET_TEMPLATE_LIST = "/messagetemplate/getlist";

//get template details
export const API_GET_TEMPLATE_DETAILS = "/messagetemplate/getdetails";

//update template
export const API_UPDATE_MAIL_TEMPLATE = "/messagetemplate/update";

//add/remove tag template
export const API_ADD_TAG_TO_TEMPLATE = "/messagetemplate/addtagtotemplate";

/*===== mail template url end ======*/

/*====== company url start ======*/
//create company type
export const API_CREATE_COMPANY_TYPE = "/companytype/createcompanytype";

//get all company type
export const API_GET_ALL_COMPANY_TYPE = "/companytype/getallcompanytype";

//get company type details
export const API_GET_COMPANY_TYPE_DETAILS =
  "/companytype/getcompanytypedetails";

//update company type
export const API_UPDATE_COMPANY_TYPE = "/companytype/updatecompanytype";

//delete company type bulk
export const API_DELETE_BULK_COMPANY_TYPE =
  "/companytype/deletebulkcompanytype";

//add new company
export const API_ADD_NEW_COMPANY = "/company/addnewcompany";

//add contract
export const API_ADD_COMPANY_CONTRACT = "/company/createcontract";

//get all company
export const API_GET_ALL_COMPANY = "/company/getallcompanylist";

//getcontracts
export const API_GET_COMPANY_CONTRACTS = "/company/getcontracts";

//getcompany by input search
export const API_GET_ALL_COMPANY_BY_SEARCH = "/company/getcompanyselectlist";

//get company details
export const API_GET_COMPANY_DETAILS = "/company/getcompanydetails";

//getcontractdetails
export const API_GET_COMPANY_CONTRACT_DETAILS = "/company/getcontractdetails";

//update company
export const API_UPDATE_COMPANY = "/company/updatecompany";

//updatecontract
export const API_UPDATE_COMPANY_CONTRACT = "/company/updatecontract";

//update bulk company
export const API_UPDATE_BULK_COMPANY = "/company/updatebulkcompany";

//delete company
export const API_DELETE_COMPANY = "/company/deletecompany";

//deletecontract
export const API_DELETE_COMPANY_CONTRACT = "/company/deletecontract";

//delete bulk company
export const API_DELETE_BULK_COMPANY = "/company/deletebulkcompany";

//deletebulkcontract
export const API_DELETE_BULK_COMPANY_CONTRACT = "/company/deletebulkcontract";

//add/update tag company
export const API_ADD_REMOVE_TAG_COMPANY = "/company/addtagtocompany";

//addremovetagcontract
export const API_ADD_REMOVE_TAG_COMPANY_CONTRACT =
  "/company/addremovetagcontract";

//add new member
export const API_ADD_NEW_COMPANY_MEMBER = "/company/addnewcompanymember";

//get all member
export const API_GET_ALL_COMPANY_MEMBERS = "/company/getallcompanymemberlist";

//get details of member
export const API_COMPANY_MEMBER_DETAILS = "/company/getcompanymemberdetails";

//get member details by query
export const API_GET_COMPANY_MEMBER_DETAILS_BY_QUERY =
  "/company/getcompanymemberdetailsbyquery";

//update member
export const API_UPDATE_COMPANY_MEMBER = "/company/updatecompanymember";

//delete member
export const API_DELETE_COMPANY_MEMBER = "/company/deletecompanymember";

//delete bulk company member
export const API_DELETE_BULK_COMPANY_MEMBER =
  "/company/deletebulkcompanymember";

//add/update tag
export const API_ADD_REMOVE_TAG_COMPANY_MEMBER =
  "/company/addtagtocompanymember";

// list company goals
export const API_GET_COMPANY_GOALS = "/company/goal/list";

// add company goal
export const API_ADD_COMPANY_GOAL = "/company/goal/add";

// update company goal
export const API_UPDATE_COMPANY_GOAL = "/company/goal/update";

// details of a company goal
export const API_COMPANY_GOAL_DETAILS = "/company/goal/details";

// delete company goal
export const API_DELETE_COMPANY_GOAL = "/company/goal/delete";

// add company massive csv upload
export const API_SAVE_COMPANIES_MASSIVEUPLOAD = "/company/massiveupload";

//assign users to bulk companies
export const API_ASSIGN_BULK_COMPANY_MEMBER =
  "/company/assignbulkcompanymember";

//addremovefollowerscompany
export const API_ADD_REMOVE_FOLLOWERS_COMPANY =
  "/company/addremovefollowerscompany";

/*====== company url end ======*/

/*==== group url start =====*/
//create group
export const API_CREATE_GROUP = "/group/creategroup";

//add member in group
export const API_ADD_NEW_GROUP_MEMBER = "/group/addnewmember";

//get all group
export const API_GET_ALL_GROUPS = "/group/getallgroups";

//get filtered groups
export const API_GET_FILTERED_GROUPS = "/group/getfilteredgroups";

//get all group options
export const API_GET_ALL_GROUP_OPTIONS = "/group/getgrouplist";

//get group details
export const API_GET_GROUP_DETAILS = "/group/getgroupdetails";

//get all group members
export const API_GET_ALL_GROUP_MEMBERS = "/group/getallmembers";

//get group member details
export const API_GET_GROUP_MEMBER_DETAILS = "/group/getmemberdetails";

//get group member details by query
export const API_GET_GROUP_MEMBER_DETAILS_BY_QUERY =
  "/group/getgroupmemberdetailsbyquery";

//update group
export const API_UPDATE_GROUP = "/group/updategroup";

//update bulk group
export const API_UPDATE_BULK_GROUP = "/group/updatebulkgroup";

//update group member
export const API_UPDATE_GROUP_MEMBER = "/group/updategroupmember";

//add/remove tag to group
export const API_ADD_REMOVE_TAG_GROUP = "/group/addremovetaggroup";

//add gallery images
export const API_ADD_GROUP_GALLERY_IMAGES = "/group/addgalleryimage";

// delete bulk group
export const API_DELETE_BULK_GROUP = "/group/deletebulkgroup";

//delete massive group members
export const API_DELETE_MASSIVE_GROUP_MEMBERS =
  "/group/deletemassivegroupmember";

//add sponsor
export const API_ADD_NEW_GROUP_COMPANY = "/group/addnewcompany";

//getallsponsors
export const API_GET_ALL_GROUP_PARTNERS = "/group/getallsponsors";

//delete gallery image
export const API_DELETE_GROUP_GALLERY_IMAGE = "/group/deletegalleryimage";

//assign bulk companies to group
export const API_ASSIGN_BULK_COMPANY_TO_GROUP =
  "/group/assignbulkcompanytogroup";

//addremovefollowersgroup
export const API_ADD_REMOVE_FOLLOWERS_GROUP = "/group/addremovefollowersgroup";

/*==== group url end =====*/

/*==== survey url start =====*/
//create survey
export const API_ADD_NEW_SURVEY = "/survey/createsurvey";

//savesurveytoinvite
export const API_SAVE_SURVEY_FEEDBACK = "/survey/savesurveyfeedback";

//invite user
export const API_INVITE_USER_SURVEY = "/survey/invitesurveytouser";

//get all survey
export const API_GET_ALL_SURVEY = "/survey/getallsurvey";

//getfiltered survey
export const API_GET_FILTERED_SURVEY = "/survey/getfilteredsurvey";

//getallsurveyinvites
export const API_GET_SURVEY_INVITES = "/survey/getallsurveyinvites";

//getfilteredsurveyinvites
export const API_GET_FILTERED_SURVEY_INVITES =
  "/survey/getfilteredsurveyinvites";

//api get survey details
export const API_GET_SURVEY_DETAILS = "/survey/getsurveydetails";

//guestsurveydetails
export const API_GET_GUEST_SURVEY_DETAILS = "/survey/guestsurveydetails";

// /getsurveyinvitedetails
export const API_GET_SURVEY_INVITE_DETAILS = "/survey/getsurveyinvitedetails";

//update survey
export const API_UPDATE_SURVEY = "/survey/updatesurvey";

export const API_SAVE_RESPONSE_SURVEY = "/survey/addresponsetosurvey";

export const API_GET_SURVEY_INVITE_RESPONSE =
  "/survey/getallsurveyinvitewithresponses";

//getallsurveyresponselist
export const API_GET_ALL_SURVEY_RESPONSE = "/survey/getallsurveyresponselist";

//getallsurveyresponsebyfilter
export const API_GET_FILTERED_SURVEY_RESPONSE =
  "/survey/getallsurveyresponsebyfilter";

//tag update
export const API_ADD_REMOVE_TAG_SURVEY = "/survey/addremovetagsurvey";
export const API_ADD_REMOVE_TAG_SURVEY_INVITE =
  "/survey/addremovetagsurveyinvite";

//get all question type
export const API_GET_ALL_QUESTIONTYPES = "/questiontype/getallquestiontype";

//add question to survey
export const API_ADD_QUESTION_TO_SURVEY = "/survey/addquestiontosurvey";

//get question details
export const API_GET_QUESTION_DETAILS = "/survey/getquestiondetails";

//update question
export const API_UPDATE_QUESTION = "/survey/updatequestion";

//delete question from survey
export const API_DELETE_QUESTION = "/survey/deletequestion";

//deletemassivesurvey
export const API_DELETE_MASSIVE_SURVEY = "/survey/deletemassivesurvey";

//deletemassiveinvites
export const API_DELETE_MASSIVE_INVITES = "/survey/deletemassiveinvites";

/*==== survey url end =====*/

/*==== mail conversation url start ====*/
//create
export const API_ADD_MESSAGE = "/message/savemail";

//get all
export const API_GET_ALL_MESSAGE = "/message/getallmails";

//get recieved mail
export const API_GET_ALL_RECIEVED_MAIL = "/message/getallrecievedmails";

//get sent mail
export const API_GET_ALL_SENT_MAIL = "/message/getallsentmails";

//get sent mail
export const API_GET_ALL_SENT_MAIL_REPORT = "/message/sentmailreport";

//get all reserve mail
export const API_GET_ALL_RESERVE_MESSAGE = "/message/getallreservemail";

//get mail details
export const API_GET_MAIL_DETAILS = "/message/getmaildetails";

//update mail
export const API_UPDATE_MAIL = "/message/updatemail";

//delete
export const API_DELETE_MESSAGE = "/message/deletemail";

//add tag mail
export const API_ADD_TAG_MAIL = "/message/addtagtomessage";

// get current user mail setting
export const API_GET_MAIL_SETTING = "/message/getusermessagesettings";

/*==== mail conversation url end ====*/

/*==== project url start ====*/

//project dashboard data
export const API_GET_PROJECTDATA_DASHBOARD = "/project/dashboard/projectdata";

//task dashboard data
export const API_GET_TASKDATA_DASHBOARD = "/project/dashboard/taskdata";

//add proejct
export const API_ADD_NEW_PROJECT = "/project/addproject";

//copy project
export const API_COPY_PROJECT = "/project/copyproject";

//getuserlistfortask
export const API_GET_USER_FOR_TASK = "/project/getuserlistfortask";

//get all project
export const API_GET_ALL_PROJECTS = "/project/getallprojects";

//getfilteredprojects
export const API_GET_FILTERED_PROJECTS = "/project/getfilteredprojects";

//getprojectlsitbysearch
export const API_GET_PROJECTLIST_BY_SEARCH = "/project/getprojectlsitbysearch";

//getalltotalprojectmembers
export const API_GET_ALL_TOTAL_PROJECT_MEMBERS =
  "/project/getalltotalprojectmembers";

//getfilteredtotalprojectmembers
export const API_GET_FILTERED_TOTAL_PROJECT_MEMBERS =
  "/project/getfilteredtotalprojectmembers";

//getprojecttaxonomies
export const API_GET_PROJECT_TAXONOMIES = "/project/getprojecttaxonomies";

//getprojectdisabilityeligibility
export const API_GET_PROJECT_DISABILITY_ELIGIBILITY =
  "/project/getprojectdisabilityeligibility";

//getprojectformdetails
export const API_GET_PROJECT_FORM_DETAILS = "/project/getprojectformdetails";

//getprojectmoduledetails
export const API_GET_PROJECT_MODULE_DETAILS =
  "/project/getprojectmoduledetails";

//get project details
export const API_GET_PROJECT_DETAILS = "/project/getprojectdetails";

//update proejct
export const API_UPDATE_PROJECT = "/project/updateproject";

// update bulk project
export const API_UPDATE_BULK_PROJECT = "/project/updatebulkproject";

//add remove tag project
export const API_ADD_REMOVE_TAG_PROJECT = "/project/addtagproject";

//add project member
export const API_ADD_PROJECT_MEMBER = "/project/addprojectmember";

//get all project members
export const API_GET_ALL_PROJECT_MEMBER = "/project/getallprojectmember";

//get project member details
export const API_GET_PROJECT_MEMBER_DETAILS =
  "/project/getprojectmemberdetails";

//getprojectmemberdetailsquery
export const API_GET_PROJECT_MEMBER_DETAILS_QUERY =
  "/project/getprojectmemberdetailsquery";

//update member
export const API_UPDATE_PROJECT_MEMBER = "/project/updateprojectmember";

//changememebrstatus
export const API_CHANGE_MEMBER_STATUS = "/project/changememebrstatus";

//add section
export const API_ADD_NEW_PROEJCT_SECTION = "/project/addsection";

//get all sections
export const API_GET_ALL_PROJECT_SECTION = "/project/getallprojectsections";

//getsectionlistoptions
export const API_GET_SECTION_LIST_OPTIONS = "/project/getsectionlistoptions";

//get section details
export const API_GET_SECTION_DETAILS = "/project/getsectiondetails";

//update section
export const API_UPDATE_PROJECT_SECTION = "/project/updateprojectsection";

//add task
export const API_ADD_NEW_PROJECT_TASK = "/project/addtask";

//update bulk task schedule
export const API_UPDATE_BULK_TASK_SCHEDULE = "/project/updatetaskbulkschedule";

//get all task
export const API_GET_ALL_TASKS = "/project/getalltasks";

//getfilteredtasks
export const API_GET_FILTERED_TASKS = "/project/getfilteredtasks";

//gettasklistbysearch
export const API_GET_TASKLIST_BY_SEARCH = "/project/gettasklistbysearch";

//getworkingtasks
export const API_GET_WORKING_TASKS = "/project/getworkingtasks";

//gettaskhistory
export const API_GET_TASK_HISTORY = "/project/gettaskhistory";

//get last saved previous task with project
export const API_GET_LAST_SAVED_TASK_DETAILS =
  "/project/getlastsavedtaskdetails";

//get task details
export const API_GET_TASK_DETAILS = "/project/gettaskdetails";

//update task
export const API_UPDATE_PROJECT_TASK = "/project/updatetask";

//updatebulktask
export const API_UPDATE_BULK_TASK = "/project/updatebulktask";

//updatetasktimer
export const API_UPDATE_TASK_TIMER = "/project/updatetasktimer";

//deactivatetask
export const API_DEACTIVATE_PROJECT_TASK = "/project/deactivatetask";

//updatetaskgantt
export const API_UPDATE_GANTT_TASK = "/project/updatetaskgantt";

//tag in task
export const API_ADD_TAG_TASK = "/project/addremovetagtask";

//add log
export const API_ADD_PROJECT_TASK_LOG = "/project/addtasklog";

//get all logs
export const API_GET_PROJECT_TASK_LOGS = "/project/getallprojectlogs";

// get filtered logs
export const API_GET_FILTERED_PROJECT_TASK_LOGS =
  "/project/getfilteredprojectlogs";

//add label to task
export const API_ADD_TAG_TASK_LOG = "/project/addremovetagtasklog";

//get log details
export const API_GET_LOG_DETAILS = "/project/getlogdetails";

//update log
export const API_UPDATE_TASK_LOG = "/project/updatetasklog";

//accept invite by member
export const API_ACCEPT_INVITE_PROJECT_MEMBER = "/project/acceptinvitebymember";

//updated tag in project member
export const API_UPDATE_TAG_PROJECT_MEMBER = "/project/updatetagprojectmember";

//assignbulktasktouser
export const API_ASSIGN_BULK_TASK = "/project/assignbulktasktouser";

export const API_ADD_REMOVE_FOLLOWERS_TASK = "/project/addremovefollowerstask";

export const API_SAVE_QUICK_TASKS = "/project/savemultipletasks";

//delete bulk project
export const API_DELETE_BULK_PROJECT = "/project/deletebulkproject";

//deletebulklogs
export const API_DELETE_BULK_LOGS = "/project/deletebulklogs";

export const API_ADD_REMOVE_FOLLOWERS_PROJECT =
  "/project/addremovefollowersproject";
/*==== project url end ====*/

/*===== list url start =====*/
//get all list type
export const API_GET_LIST_TYPE = "/listtype/getalllisttype";

//create list
export const API_CREATE_LIST = "/list/addnewlist";

//get all list
export const API_GET_ALL_LIST = "/list/getalllist";

//get list details
export const API_LIST_DETAILS = "/list/getlistdetails";

//get List details with items
export const API_LIST_DETAILS_WITH_ITEMS = "/list/getlistdetailswithitems";

//update list
export const API_UPDATE_A_LIST = "/list/updatelist";

//delete list
export const API_DELETE_A_LIST = "/list/deletelist";

//deleteitemfromlist
export const API_DELETE_ITEM_FROM_LIST = "/list/deleteitemfromlist";

//add tag list
export const API_ADD_REMOVE_TAG_LIST = "/list/addtagtolist";

/*===== list url end =====*/

/* challenge url start */
//create challenge
export const API_ADD_CHALLENGE = "/challenge/createchallenge";

//get all challenge
export const API_GET_ALL_CHALLENGE = "/challenge/getallchallenges";

//getfilteredchallenges
export const API_GET_FILTERED_CHALLENGE = "/challenge/getfilteredchallenges";

//getchallengefullreport
export const API_GET_CHALLENGE_FULL_REPORT =
  "/challenge/getchallengefullreport";

//getchallengelistforoptions
export const API_GET_CHALLENGE_LIST_FOR_OPTIONS =
  "/challenge/getchallengelistforoptions";

//get details of challenge
export const API_GET_CHALLENGE_DETAILS = "/challenge/getchallengedetails";

//get all response
export const API_GET_ALL_CHALLENGE_RESPONSE =
  "/challenge/getallchallengeresponses";

//getchallengeresponsedetails
export const API_GET_CHALLENGE_RESPONSE_DETAILS = "/challenge/responsedetails";

//getchallengeresponsedetails
export const API_GET_CHALLENGE_RESPONSE_CV_DETAILS =
  "/challenge/responsecvdetails";

//get capital quest details
export const API_GET_CHALLENGE_RESPONSE_CQ_DETAILS =
  "/capitalquest/getcapitalquestdetails";

//update capital quest details
export const API_UPDATE_CHALLENGE_RESPONSE_CQ_DETAILS =
  "/capitalquest/updatecapitalquestdetails";

// save capital quest response
export const API_SAVE_CAPITALQUEST_RESPONSE = "/challenge/capitalquestresponse";

//getchallengeresponsedetails
export const API_GET_CV_DETAILS = "/cv/getcvdetails";

//create cv
export const API_CREATE_CV = "/cv/createcv";

//getcvdetailsbyquery
export const API_GET_CV_DETAILS_BY_QUERY = "/cv/getcvdetailsbyquery";

//updatecv
export const API_UPDATE_CV = "/cv/updatecv";

//update challenge
export const API_UPDATE_CHALLENGE = "/challenge/updatechallenge";

//update bulk
export const API_UPDATE_BULK_CHALLENGE = "/challenge/updatebulkchallenge";

//updatechallengeresponse
export const API_UPDATE_CHALLENGE_RESPONSE =
  "/challenge/updatechallengeresponse";

//changeapprovalstatus
export const API_CHANGE_APPROVAL_STATUS = "/challenge/changeapprovalstatus";

//add label
export const API_ADD_LABEL_CHALLENGE = "/challenge/addremovetagchallenge";

//add new process
export const API_ADD_NEW_JOB_PROCESS = "/challenge/addnewjobprocess";

//getalljobprocess
export const API_GET_ALL_JOB_PROCESS = "/challenge/getalljobprocess";

//get process details
export const API_GET_JOB_PROCESS_DETAILS = "/challenge/getprocessdetails";

//update process
export const API_UPDATE_JOB_PROCESS = "/challenge/updatejobprocess";

//add new member
export const API_ADD_NEW_JOB_MEMBER = "/challenge/addchallengemember";

//get all member
export const API_GET_ALL_JOB_MEMBER = "/challenge/getallmembers";

//getjobmemberdetails
export const API_GET_JOB_MEMBER_DETAILS = "/challenge/getjobmemberdetails";

//updatechallengemember
export const API_UPDATE_JOB_MEMBER = "/challenge/updatechallengemember";

//addremovetagjobmemember
export const API_ADD_REMOVE_TAG_JOB_MEMBER =
  "/challenge/addremovetagjobmemember";

//addremovetag challengeresponse
export const API_ADD_REMOVE_TAG_CHALLENGE_RESPONSE =
  "/challenge/updatetagchallengeresponse";

//getcvdetails
export const API_GUEST_CV_DETAILS = "/challenge/guestchallengeresponsedetails";
export const API_GUEST_CHALLENGE_RESPONSE_DETAILS =
  "/challenge/guestchallengeresponsedetails";

export const API_CHALLENGE_SAVE_CUSTOMER_FEEDBACK =
  "/challenge/response/customerfeedback";

export const API_CHALLENGE_GET_CUSTOMER_FEEDBACK =
  "/challenge/response/getcustomerfeedbacks";

export const API_CHALLENGE_GET_PROVIDER_FEEDBACK =
  "/challenge/response/getproviderfeedbacks";

export const API_CHALLENGE_CHANGE_WINNER_STATUS =
  "/challenge/response/challengewinnerselection";

//deletebulkchallenge
export const API_DELETE_BULK_CHALLENGE = "/challenge/deletebulkchallenge";

//get challengedashboard response
export const API_GET_CHALLENGE_DASHBOARD_DATA =
  "/challenge/getchallengedashboarddata";

export const API_ADD_REMOVE_FOLLOWERS_CHALLENGE =
  "/challenge/addremovefollowerschallenge";

/* challenge url end */

/* agenda url start */
//add new agenda
export const API_ADD_NEW_AGENDA = "/agenda/addnewagenda";

//add settings to agenda
export const API_SETTINGS_TO_AGENDA = "/agenda/addtoagenda";

//get all agenda
export const API_GET_ALL_AGENDA = "/agenda/getallagenda";

//get details
export const API_GET_DETAILS_AGENDA = "/agenda/getagendadetails";

//update agenda
export const API_UPDATE_AGENDA = "/agenda/updateagenda";

//delete agenda
export const API_DELETE_AGENDA = "/agenda/deleteagenda";

//tag
export const API_ADD_REMOVE_TAG_AGENDA = "/agenda/addremovetagagenda";
/* agenda url end */

// Invoice start
export const API_CREATE_INVOICE = "/invoice/createinvoice";

//getinvoicelistoptions
export const API_GET_INVOICE_LIST_OPTIONS = "/invoice/getinvoicelistoptions";

//getinvoicehistory
export const API_GET_INVOICE_HISTORY = "/invoice/getinvoicehistory";

export const API_UPDATE_INVOICE = "/invoice/updateinvoice";

export const API_INVOICE_DETAILS = "/invoice/getinvoicedetails";

export const API_GET_MY_INVOICES = "/invoice/getinvoices";

//getfilteredinvoices
export const API_GET_FILTERED_INVOICES = "/invoice/getfilteredinvoices";

export const API_INVOICE_ADD_NOTE = "/invoice/addnote";

export const API_DELETE_INVOICE = "/invoice/deleteinvoice";

export const API_ADD_REMOVE_TAG_INVOICE = "/invoice/addremovetaginvoice";

export const API_ADD_REMOVE_FOLLOWERS_INVOICE =
  "/invoice/addremovefollowersinvoice";

export const API_CREATE_GUEST_INVOICE = "/invoice/createguestinvoice";

// Payment start
export const API_GET_MY_PAYMENTS = "/payment/mypayments";

// Subscription start
export const API_GET_MY_SUBSCRIPTIONS = "/plan/mysubscriptions";

/*------ product url start ------*/
//add product type
export const API_ADD_PRODUCT_TYPE = "/product/addproducttype";

//get all product type
export const API_GET_ALL_PRODUCT_TYPE = "/product/getallproducttype";

//get all product type list
export const API_GET_ALL_PRODUCT_TYPE_LIST = "/producttype/getallproducttypes";

//get product type details
export const API_GET_PRODUCT_TYPE_DETAILS = "/product/getproducttypedetails";

/*------ event type url start ------*/
//add event type
export const API_ADD_EVENT_TYPE = "/eventtype/createeventtype";

//get all event type
export const API_GET_ALL_EVENT_TYPES = "/eventtype/getalleventtypes";

//get event type details
export const API_GET_EVENT_TYPE_DETAILS = "/eventtype/geteventtypedetails";

//update event type
export const API_UPDATE_EVENT_TYPE = "/eventtype/updateeventtype";

//delete bulk event type
export const API_DELETE_BULK_EVENT_TYPE = "/eventtype/deletebulkeventtype";
/*------ event type url end ------*/

//add product
export const API_ADD_PRODUCT = "/product/addproduct";

//addproductpricing
export const API_ADD_PRODUCT_PRICING = "/product/addproductpricing";

// get all products
export const API_GET_ALL_PRODUCTS = "/product/getallproducts";

//getfilteredproducts
export const API_GET_FILTERED_PRODUCTS = "/product/getfilteredproducts";

//getallproductslist
export const API_GET_ALL_PRODUCTS_LIST = "/product/getproductlists";

//getallproductpricings
export const API_GET_ALL_PRODUCT_PRICINGS = "/product/getallproductpricings";

//getfilteredproductpricings
export const API_GET_FILTERED_PRODUCT_PRICINGS =
  "/product/getfilteredproductpricings";

//get product details
export const API_GET_PRODUCT_DETAILS = "/product/getproductdetails";

//getproductpricingdetails
export const API_GET_PRODUCT_PRICING_DETAILS =
  "/product/getproductpricingdetails";

//update product type
export const API_UPDATE_PRODUCT_TYPE = "/producttype/updateproducttype";

//update product
export const API_UPDATE_PRODUCT = "/product/updateproduct";

//updateproductpricing
export const API_UPDATE_PRODUCT_PRICING = "/product/updateproductpricing";

//delete bulk product type
export const API_DELETE_BULK_PRODUCT_TYPE = "/product/deletebulkproducttype";

//deletebulkproduct
export const API_DELETE_BULK_PRODUCT = "/product/deletebulkproduct";

//deletebulkproductpricing
export const API_DELETE_BULK_PRODUCT_PRICING =
  "/product/deletebulkproductpricing";

//addremovetagproduct
export const API_ADD_REMOVE_TAG_PRODUCT = "/product/addremovetagproduct";

export const API_GET_PRODUCTS_BY_QUERY = "/product/getproductsbyquery";

export const API_GET_ALL_PRODUCTS_SELECT = "/product/getproductselectlist";

export const API_GET_ALL_CUSTOMER_PRICINGS = "/productpricelistcustomer/getall";

//getfiltered
export const API_GET_FILTERED_CUSTOMER_PRICINGS =
  "/productpricelistcustomer/getfiltered";

//product customer pricing

// Bulk Create
export const API_BULK_CREATE_PRODUCT_CUSTOMER_PRICING =
  "/productpricelistcustomer/bulkcreate";

// Bulk Update
export const API_BULK_UPDATE_PRODUCT_CUSTOMER_PRICING =
  "/productpricelistcustomer/bulkupdate";

// Bulk Delete
export const API_BULK_DELETE_PRODUCT_CUSTOMER_PRICING =
  "/productpricelistcustomer/bulkdelete";

// Manage Tags
export const API_ADD_REMOVE_TAG_PRODUCT_CUSTOMER_PRICING =
  "/productpricelistcustomer/addremovetag";

/*------ product url end ------*/

/* activity process url start */
//save process
export const API_ADD_NEW_PROCESS = "/activityprocess/createprocess";

//save history
export const API_SAVE_PROCESS_HISTORY = "/activityprocess/saveprocesshistory";

//get process
export const API_GET_ALL_PROCESS = "/activityprocess/getallprocess";

//getprocessdetails
export const API_GET_PROCESS_DETAILS = "/activityprocess/getprocessdetails";

//updateprocess
export const API_UPDATE_PROCESS = "/activityprocess/updateprocess";

//updatekanabn
export const API_UPDATE_KANBAN = "/activityprocess/updatekanban";

//remove card kanban
export const API_REMOVE_CARD_ITEM_KANBAN = "/activityprocess/removecardkanban";

//add new column kanban
export const API_ADD_NEW_COLUMN_KANBAN = "/activityprocess/addnewcolumnkanban";

// Tickets start
export const API_GET_MY_TICKETS = "/tickets/getalltickets";

export const API_GET_TICKETS_CUSTOMER = "/tickets/getallcustomers";

export const API_GET_AVG_SALES = "/tickets/avgsales";

export const API_GET_TICKET_BY_YEAR = "/tickets/ticketperyear";

export const API_GET_TICKET_BY_MONTH = "/tickets/ticketpermonth";

export const API_GET_SALES_BY_CHANNEL = "/tickets/salesbychannel";

export const API_GET_TICKET_DAYS_OF_WEEK = "/tickets/ticketperdayofweek";

export const API_GET_TICKET_BY_GENDER = "/tickets/ticketbygender";

export const API_GET_TICKET_BY_PRICE = "/tickets/ticketbyprice";

export const API_GET_TICKET_BY_PROMOTION = "/tickets/ticketbypromotion";

export const API_GET_TICKET_BY_SECTOR = "/tickets/ticketbysector";

export const API_GET_TICKET_BY_BILL = "/tickets/ticketbybill";

export const API_GET_TICKET_BY_WORK = "/tickets/ticketbywork";

export const API_GET_BEST_BUYER = "/tickets/bestbuyer";

export const API_SAVE_TICKETS_BYCSV = "/tickets/bulkupload";

export const API_GET_TICKET_INCOME = "/tickets/ticketsandincome";

export const API_GET_TICKET_EVENT_EARNING = "/tickets/earningbyevent";

export const API_GET_TICKET_CHANNEL_EARNING = "/tickets/earningbychannel";

export const API_GET_TICKET_ZONE_EARNING = "/tickets/earningbyzone";

export const API_GET_TICKET_ONLY_MADRID = "/tickets/databymadrid";

export const API_GET_TICKET_WITH_EMAIL = "/tickets/datawithemail";

export const API_GET_TICKET_WITH_ZIPCODE = "/tickets/datawithzipcode";

export const API_GET_TICKET_DIFF_DATE = "/tickets/dataticketdifferentdate";

export const API_GET_TICKET_INCOME_ZIPCODE = "/tickets/incomebyzipcode";

export const API_GET_TICKET_COUNT_UNIQUE_CUSTOMER =
  "/tickets/uniquecustomercount";

export const API_GET_TICKET_COUNT_ALL_CUSTOMER = "/tickets/allcustomercount";

export const API_GET_TICKET_ORGANIZATION_SURCHARGE =
  "/tickets/organizationsurcharge";

// filter options
export const API_TICKETS_FILTER_OPTIONS = "/tickets/filteroptions";

/* tickets url end */

/*==== action logs ====*/
export const API_GET_ACTION_LOGS = "/actionlogs/getlogs";

//gpt

//create
export const API_CREATE_GPTPROMPTS = "/gptprompt/createprompt";

//get all prompts
export const API_GET_ALL_GPTPROMPTS = "/gptprompt/getprompts";

//details
export const API_GET_DETAILS_GPTPROMPT = "/gptprompt/getpromptdetails";

//update
export const API_UPDATE_GPTPROMPTS = "/gptprompt/updateprompt";

// delete bulk gpt prompt
export const API_DELETE_BULK_GPTPROMPT = "/gptprompt/deletebulkgptprompt";

//** Filter url start */
//create filter
export const API_ADD_NEW_FILTER = "/filter/createfilter";

//get all filters
export const API_GET_ALL_FILTER = "/filter/getfilters";

//get default filter
export const API_GET_DEFAULT_FILTER = "/filter/getdefaultfilter";

//update filter
export const API_UPDATE_FILTER = "/filter/updatefilter";

//delete filter
export const API_DELETE_FILTER = "/filter/deletefilter";

//** Filter url end */
//alert url start
//add alert
export const API_ADD_NEW_ALERT = "/alert/createalert";

//get all alert
export const API_GET_ALL_TODAYS_ALERT = "/alert/gettodaysalerts";

//get all other days alert
export const API_GET_ALL_OTHERDAYS_ALERT = "/alert/getotherdaysalerts";

//get alert details
export const API_GET_ALERT_DETAILS = "/alert/getalert";

//update alert
export const API_UPDATE_ALERT = "/alert/updatealert";

//delete alert
export const API_DELETE_ALERT = "/alert/deletealert";

//alert url end

//note url start
//add note
export const API_ADD_NEW_NOTE = "/note/createnote";

//get all note
export const API_GET_ALL_NOTE = "/note/getallnotes";

//get all crm note
export const API_GET_ALL_CRM_NOTE = "/note/getallcrmnotes";

//get note details
export const API_GET_NOTE_DETAILS = "/note/getnotedetails";

//update note
export const API_UPDATE_NOTE = "/note/updatenote";

//update bulk note
export const API_UPDATE_BULK_NOTE = "/note/updatebulknote";

//delete note
export const API_DELETE_NOTE = "/note/deletenote";

//delete bulk note
export const API_DELETE_BULK_NOTE = "/note/deletebulknote";

//addremovetagnote
export const API_ADD_REMOVE_TAG_NOTE = "/note/addremovetagnote";

//note url end

//course url start

//add new upload content
export const API_ADD_NEW_CONTENT = "/course/addnewcontent";

//add new course
export const API_ADD_NEW_COURSE = "/course/createcourse";

//add new chapter
export const API_ADD_NEW_COURSE_CHAPTER = "/course/addnewchapter";

//add new lesson
export const API_ADD_NEW_COURSE_LESSON = "/course/addnewlesson";

//add new member
export const API_ADD_NEW_COURSE_MEMBER = "/course/addnewmember";

//add new subscriber
export const API_ADD_NEW_COURSE_SUBSCRIBER = "/course/addnewsubscriber";

//get all course
export const API_GET_ALL_COURSE_RECORDS = "/course/getallcourse";

//getfilteredcourse
export const API_GET_FILTERED_COURSE = "/course/getfilteredcourse";

//getcourselistforoptions
export const API_GET_COURSE_LIST_FOR_OPTIONS =
  "/course/getcourselistforoptions";

//getmemberlistoptions
export const API_GET_COURSE_MEMBER_LIST_OPTIONS =
  "/course/getmemberlistoptions";

//get all chapters
export const API_GET_ALL_COURSE_CHAPTERS = "/course/getallchapters";

//getchapterlistoptions
export const API_GET_COURSE_CHAPTER_LIST_OPTIONS =
  "/course/getchapterlistoptions";

//get all lessons
export const API_GET_ALL_COURSE_LESSONS = "/course/getalllessons";

//getlessonlistoptions
export const API_GET_COURSE_LESSON_LIST_OPTIONS =
  "/course/getlessonlistoptions";

//get all course members
export const API_GET_ALL_COURSE_MEMBERS = "/course/getallcoursemembers";

//get all course subscribers
export const API_GET_ALL_COURSE_SUBSCRIBERS = "/course/getallcoursesubscribers";

//getallsubmittedtasks
export const API_GET_ALL_COURSE_LESSON_TASKS = "/course/getallcourselesontasks";

//getallsubmittedtasks
export const API_GET_ALL_COURSE_TASKS = "/course/getallcoursetask";

//getallfilteredcoursetask
export const API_GET_FILTERED_COURSE_TASKS = "/course/getallfilteredcoursetask";

//getallcoursefaqlist
export const API_GET_ALL_COURSE_FAQ_LIST = "/course/getallcoursefaqlist";

//getcoursecertificatelist
export const API_GET_COURSE_CERTIFICATE_LIST =
  "/course/getcoursecertificatelist";

//get content details
export const API_GET_CONTENT_DETAILS = "/course/getcontentdetails";

//get course details
export const API_GET_COURSE_DETAILS = "/course/getcoursedetails";

//getcoursememberdetails
export const API_GET_COURSE_MEMBER_DETAILS = "/course/getcoursememberdetails";

//delete massive course member
export const API_DELETE_MASSIVE_COURSE_MEMBER =
  "/course/deletemassivecoursemember";

//getcoursesubsriberdetails
export const API_GET_COURSE_SUBSCRIBER_DETAILS =
  "/course/getcoursesubsriberdetails";

//getcoursechapterdetails
export const API_GET_COURSE_CHAPTER_DETAILS = "/course/getcoursechapterdetails";

//getcourselessondetails
export const API_GET_COURSE_LESSON_DETAILS = "/course/getcourselessondetails";

//getlessontaskdetails
export const API_GET_LESSON_TASK_DETAILS = "/course/getlessontaskdetails";

//getcertificatedetails
export const API_GET_CERTIFICATE_DETAILS = "/course/getcertificatedetails";

//update content
export const API_UPDATE_CONTENT = "/course/updatecontent";

//update course
export const API_UPDATE_COURSE = "/course/updatecourse";

//update massive course
export const API_UPDATE_MASSIVE_COURSE = "/course/updatemassivecourse";

//updatecoursemember
export const API_UPDATE_COURSE_MEMBER = "/course/updatecoursemember";

//updatecoursechapter
export const API_UPDATE_COURSE_CHAPTER = "/course/updatecoursechapter";

//updatecoursesubscriber
export const API_UPDATE_COURSE_SUBSCRIBER = "/course/updatecoursesubscriber";

//updatemassivecoursechapters
export const API_UPDATE_MASSIVE_COURSE_CHAPTERS =
  "/course/updatemassivecoursechapters";

//updatecourselesson
export const API_UPDATE_COURSE_LESSON = "/course/updatecourselesson";

//updatemassivecourselessons
export const API_UPDATE_MASSIVE_COURSE_LESSONS =
  "/course/updatemassivecourselessons";

//updatelessonassignment
export const API_UPDATE_LESSON_ASSIGNMENT = "/course/updatelessonassignment";

//delete course
export const API_DELETE_COURSE = "/course/deletecourse";

//delete massive course
export const API_DELETE_MASSIVE_COURSE = "/course/deletemassivecourse";

//deletecoursechapter
export const API_DELETE_COURSE_CHAPTER = "/course/deletecoursechapter";

//delete massive course chapter
export const API_DELETE_MASSIVE_COURSE_CHAPTERS =
  "/course/deletemassivecoursechapters";

//deletecourselesson
export const API_DELETE_COURSE_LESSON = "/course/deletecourselesson";

//delete massive course lesson
export const API_DELETE_MASSIVE_COURSE_LESSONS =
  "/course/deletemassivecourselessons";

// delete massive course subscriber
export const API_DELETE_MASSIVE_COURSE_SUBSCRIBER =
  "/course/deletemassivecoursesubscriber";

//delete content
export const API_DELETE_CONTENT = "/course/deletecontent";

//addremovetagcourse
export const API_ADD_REMOVE_TAG_COURSE = "/course/addremovetagcourse";

//addremovetagcoursemember
export const API_ADD_REMOVE_TAG_COURSE_MEMBER =
  "/course/addremovetagcoursemember";

// add remove tag in course subscriber
export const API_ADD_REMOVE_TAG_COURSE_SUBSCRIBER =
  "/course/addremovetagcoursesubscriber";

export const API_ADD_REMOVE_FOLLOWERS_COURSE =
  "/course/addremovefollowerscourse";

//end course

//direct access start
//add new direct access
export const API_ADD_DIRECT_ACCESS = "/directaccess/adddirectaccess";

//get all direct access
export const API_GET_ALL_DIRECT_ACCESS = "/directaccess/getalldirectaccess";

//get direct access detials
export const API_GET_DIRECT_ACCESS_DETAILS =
  "/directaccess/getdirectaccessdetails";

//update direct access
export const API_UPDATE_DIRECT_ACCESS = "/directaccess/updatedirectaccess";

//delete direct access
export const API_DELETE_DIRECT_ACCESS = "/directaccess/deletedirectaccess";

//delete massive direct access
export const API_DELETE_MASSIVE_DIRECT_ACCESS =
  "/directaccess/deletemassivedirectaccess";

//addremovetagdirectaccess
export const API_ADD_REMOVE_TAG_DIRECT_ACCESS =
  "/directaccess/addremovetagdirectaccess";

//direct access end

//invoice doc url start

//saveinvoicedoc
export const API_SAVE_INVOICE_DOC = "/invoicedoc/saveinvoicedoc";

//get all invoce docs
export const API_GET_ALL_INVOICE_DOCS = "/invoicedoc/getallinvoicedocs";

//getallinvoicedocdetails
export const API_GET_ALL_INVOICE_DOC_DETAILS =
  "/invoicedoc/getallinvoicedocdetails";

//updateinvoicedoc
export const API_UPDATE_INVOICE_DOC = "/invoicedoc/updateinvoicedoc";

//delete bulk docs
export const API_DELETE_BULK_INVOICE_DOCS = "/invoicedoc/deletebulkinvoicedocs";

//add/remove tags
export const API_ADD_REMOVE_TAG_INVOICE_DOC = "/invoicedoc/taginvoicedoc";

// challange response ai suggest
export const API_CHALLENGE_RESPONSE_AI_SUGGEST = "/ai/cv/evaluate";

// challange response ai suggest
export const API_CHALLENGE_MULTI_RESPONSE_AI_SUGGEST = "/ai/multicv/evaluate";

// ai lead recommendation
export const API_AI_LEAD_RECOMMENDATION = "/ai/lead/recommendation";

// --- KANBAN -------------------------------
export const API_GET_PROCESS_TAGS = "/activityprocess/tagbyprocess";

export const API_DELETE_COMPONENTORDER =
  "/activityprocess/deletecomponentorder";

//Leads ------------------
export const API_GET_COMPONENTORDER_LEAD_BY_TAGS =
  "/activityprocess/getcomponentorder/lead";

export const API_POST_UPDATE_COMPONENTORDER_LEAD =
  "/activityprocess/updatecomponentorder/lead";

//Opportunities ----------
export const API_GET_COMPONENTORDER_OPPORTUNITY_BY_TAGS =
  "/activityprocess/getcomponentorder/opportunity";

export const API_POST_UPDATE_COMPONENTORDER_OPPORTUNITY =
  "/activityprocess/updatecomponentorder/opportunity";

//Quotations ------------------
export const API_GET_COMPONENTORDER_QUOTATIONS_BY_TAGS =
  "/activityprocess/getcomponentorder/quotations";

export const API_POST_UPDATE_COMPONENTORDER_QUOTATION =
  "/activityprocess/updatecomponentorder/quotation";

//task
export const API_GET_COMPONENTORDER_TASK_BY_TAGS =
  "/activityprocess/getcomponentorder/task";

export const API_POST_UPDATE_COMPONENTORDER_TASK =
  "/activityprocess/updatecomponentorder/task";

// challenge response
export const API_GET_CHALLENGE_RESPONSE_BY_TAGS =
  "/activityprocess/getcomponentorder/challengeresponse";

export const API_POST_UPDATE_CHALLENGE_RESPONSE =
  "/activityprocess/updatecomponentorder/challengeresponse";

// --- KANBAN -------------------------------

/** setting url start */

//create settings
export const API_CREATE_SETTING = "/settings/create";

//details setting
export const API_GET_SETTING_DETAILS = "/settings/details";

//getwarehouseaddress
export const API_GET_WAREHOUSE_ADDRESS = "/settings/getwarehouseaddress";

/** setting url end */

/** inventory url start */

//create inventory
export const API_CREATE_INVENTORY = "/inventory/create";

//get all inventory
export const API_GET_ALL_INVENTORIES = "/inventory/getall";

//get all inventory by filter
export const API_GET_ALL_INVENTORIES_BY_FILTER = "/inventory/getfiltered";

//get inventory by id
export const API_GET_INVENTORY_DETAILS = "/inventory/details";

//update inventory
export const API_UPDATE_INVENTORY = "/inventory/update";

//delete inventory in bulk
export const API_DELETE_INVENTORY = "/inventory/deletebulk";

//addremovetaginventory
export const API_ADD_REMOVE_TAG_INVENTORY = "/inventory/addremovetaginventory";

/** inventory url end */

//createfaq
export const API_CREATE_FAQ = "/faq/createfaq";

export const API_CREATE_FAQ_BYLIST = "/faq/createfaqbylist";

//generatedebate
export const API_GENERATE_DEBATE = "/faq/generatedebate";

//getallfaqs
export const API_GET_ALL_FAQS = "/faq/getallfaqs";

//getfaqdetails
export const API_GET_FAQ_DETAILS = "/faq/detailsfaq";

//updatefaq
export const API_UPDATE_FAQ = "/faq/updatefaq";

//updatemassivefaq
export const API_UPDATE_MASSIVE_FAQ = "/faq/updatemassivefaq";

//deletefaq
export const API_DELETE_FAQ = "/faq/deletefaq";

//deletemassivefaq
export const API_DELETE_MASSIVE_FAQ = "/faq/deletemassivefaq";

// index faq for search
export const API_INDEX_MASSIVE_FAQ = "/faq/indexmassivefaq";

// search faq by index
export const API_SEARCH_FAQ_BY_INDEX = "/faq/searchfaqbyindex";

//addremovetagfaq
export const API_ADD_REMOVE_TAG_FAQ = "/faq/addremovetagfaq";

//end faq

// project taxonomy
//create
export const API_CREATE_PROJECT_TAXONOMY = "/projecttypetaxonomy/create";

//get all
export const API_GET_ALL_PROJECT_TAXONOMY = "/projecttypetaxonomy/getall";

//get details
export const API_GET_PROJECT_TAXONOMY_DETAILS = "/projecttypetaxonomy/details";

//update
export const API_UPDATE_PROJECT_TAXONOMY = "/projecttypetaxonomy/update";

// Automation url start
export const API_AUTOMATION_CONFIG = "/automation";

// Automation Details
export const API_AUTOMATION_CONFIG_DETAILS = "/automation/details";

// Automaton Events
export const API_AUTOMATION_EVENTS = "/automation/events";

// Automation Events Details
export const API_AUTOMATION_EVENTS_DETAILS = "/automation/event/details";

// Pause and automation event
export const API_PAUSE_AUTOMATION_EVENT = "/automation/event/pause";

// Get automation names as list for select
export const API_AUTOMATION_LIST_SELECT = "/automation/select";

// stop automations in bulk
export const API_AUTOMATION_EVENTS_STOP = "/automation/events/bulkstop";

// add remove tags in automation event
export const API_ADD_REMOVE_TAG_AUTOMATION_EVENT =
  "/automation/event/addremovetag";

// Get modules by slug
export const API_GET_MODULES_BY_SLUG = "/module/getmodulesbyslug";

//time line url
//gettimelineevents
export const API_GET_TIMELINE_EVENTS = "/timeline/gettimelineevents";

// Feedback Rule URLs
export const API_CREATE_FEEDBACK_RULE = "/feedbackrules/create";

export const API_GET_FEEDBACK_RULES = "/feedbackrules/getall";

export const API_GET_FEEDBACK_RULE_DETAILS = "/feedbackrules/details";

export const API_UPDATE_FEEDBACK_RULE = "/feedbackrules/update";

export const API_DELETE_FEEDBACK_RULE = "/feedbackrules/delete";

export const API_DELETE_BULK_FEEDBACK_RULES = "/feedbackrules/deletebulk";

export const API_ADD_REMOVE_TAG_FEEDBACK_RULE = "/feedbackrules/addremovetag";

//getsurveylistbyfeedbackrule
export const API_GET_SURVEY_LIST_BY_FEEDBACK_RULE =
  "/feedbackrules/getsurveylistbyfeedbackrule";

/**
 * Patient management url start.
 */
/*Allergy url start */
//1. Create Allergy
export const API_ADD_ALLERGY = "/allergy/add";

// 2. Get All Allergy
export const API_GET_ALL_ALLERGY = "/allergy/getall";

// 3. Get Allergy by ID
export const API_GET_ALLERGY_BY_ID = "/allergy/details";

// 4. Update Allergy
export const API_UPDATE_ALLERGY = "/allergy/update";

// 5. Update bulk Allergy
export const API_UPDATE_BULK_ALLERGY = "/allergy/updatebulk";

// 6. Delete Allergy
export const API_DELETE_ALLERGY = "/allergy/delete";

// 7. Delete bulk Allergy
export const API_DELETE_BULK_ALLERGY = "/allergy/deletebulk";

// 8. Assign user to allergy
export const API_ASSIGN_USER_ALLERGY = "/allergy/assignuserinbulk";

/*Allergy url end */

/* Blood Pressure url start */
// 1. Create Blood Pressure
export const API_CREATE_BLOOD_PRESSURE = "/bloodpressure/create";

// 2. Get All Blood Pressure
export const API_GET_ALL_BLOOD_PRESSURE = "/bloodpressure/getall";

// 3. Get Blood Pressure by ID
export const API_GET_BLOOD_PRESSURE_BY_ID = "/bloodpressure/details";

// 4. Update Blood Pressure
export const API_UPDATE_BLOOD_PRESSURE = "/bloodpressure/update";

// 5. Update bulk Blood Pressure
export const API_UPDATE_BULK_BLOOD_PRESSURE = "/bloodpressure/updatebulk";

// 6. Delete Blood Pressure
export const API_DELETE_BLOOD_PRESSURE = "/bloodpressure/delete";

// 7. Delete bulk Blood Pressure
export const API_DELETE_BULK_BLOOD_PRESSURE = "/bloodpressure/deletebulk";

// 8. Assign user to Blood Pressure
export const API_ASSIGN_USER_BLOOD_PRESSURE = "/bloodpressure/assignuserinbulk";
/* Blood Pressure url end */

/* Immunization url start */
// 1. Create Immunization
export const API_ADD_IMMUNIZATION = "/immunization/add";

// 2. Get All Immunization
export const API_GET_ALL_IMMUNIZATION = "/immunization/getall";

// 3. Get Immunization by ID
export const API_GET_IMMUNIZATION_BY_ID = "/immunization/details";

// 4. Update Immunization
export const API_UPDATE_IMMUNIZATION = "/immunization/update";

// 5. Update bulk Immunization
export const API_UPDATE_BULK_IMMUNIZATION = "/immunization/updatebulk";

// 6. Delete Immunization
export const API_DELETE_IMMUNIZATION = "/immunization/delete";

// 7. Delete bulk Immunization
export const API_DELETE_BULK_IMMUNIZATION = "/immunization/deletebulk";

// 8. Assign user to Immunization
export const API_ASSIGN_USER_IMMUNIZATION = "/immunization/assignuserinbulk";

/* Immunization url end */

/*medicaltest url start */
// 1. Create medicaltest
export const API_ADD_MEDICAL_TEST = "/medicaltest/add";

// 2. Get All medicaltest
export const API_GET_ALL_MEDICAL_TEST = "/medicaltest/getall";

// 3. Get medicaltest by ID
export const API_GET_MEDICAL_TEST_BY_ID = "/medicaltest/details";

// 4. Update medicaltest
export const API_UPDATE_MEDICAL_TEST = "/medicaltest/update";

// 5. Update bulk medicaltest
export const API_UPDATE_BULK_MEDICAL_TEST = "/medicaltest/updatebulk";

// 6. Delete medicaltest
export const API_DELETE_MEDICAL_TEST = "/medicaltest/delete";

// 7. Delete bulk medicaltest
export const API_DELETE_BULK_MEDICAL_TEST = "/medicaltest/deletebulk";

// 8. Assign user to medicaltest
export const API_ASSIGN_USER_MEDICAL_TEST = "/medicaltest/assignuserinbulk";

/*medicaltest url end */

/* medicaldocument url start  */
// 1. Create medicaldocument
export const API_ADD_MEDICAL_DOCUMENT = "/medicaldocument/add";

// 2. Get All medicaldocument
export const API_GET_ALL_MEDICAL_DOCUMENT = "/medicaldocument/getall";

// 3. Get medicaldocument by ID
export const API_GET_MEDICAL_DOCUMENT_BY_ID = "/medicaldocument/details";

// 4. Update medicaldocument
export const API_UPDATE_MEDICAL_DOCUMENT = "/medicaldocument/update";

// 5. Update bulk medicaldocument
export const API_UPDATE_BULK_MEDICAL_DOCUMENT = "/medicaldocument/updatebulk";

// 6. Delete medicaldocument
export const API_DELETE_MEDICAL_DOCUMENT = "/medicaldocument/delete";

// 7. Delete bulk medicaldocument
export const API_DELETE_BULK_MEDICAL_DOCUMENT = "/medicaldocument/deletebulk";

// 8. Assign user to medicaldocument
export const API_ASSIGN_USER_MEDICAL_DOCUMENT =
  "/medicaldocument/assignuserinbulk";

/* medicaldocument url end  */

/*heartrate url start */
// 1. Create heartrate
export const API_CREATE_HEART_RATE = "/heartrate/create";

// 2. Get All heartrate
export const API_GET_ALL_HEART_RATE = "/heartrate/getall";

// 3. Get heartrate by ID
export const API_GET_HEART_RATE_BY_ID = "/heartrate/details";

// 4. Update heartrate
export const API_UPDATE_HEART_RATE = "/heartrate/update";

// 5. Update bulk heartrate
export const API_UPDATE_BULK_HEART_RATE = "/heartrate/updatebulk";

// 6. Delete heartrate
export const API_DELETE_HEART_RATE = "/heartrate/delete";

// 7. Delete bulk heartrate
export const API_DELETE_BULK_HEART_RATE = "/heartrate/deletebulk";

// 8. Assign user to heartrate
export const API_ASSIGN_USER_HEART_RATE = "/heartrate/assignuserinbulk";
/*heartrate url end */

/*temperature url start */
// 1. Create temperature
export const API_CREATE_TEMPERATURE = "/temperature/create";

// 2. Get All temperature
export const API_GET_ALL_TEMPERATURE = "/temperature/getall";

// 3. Get temperature by ID
export const API_GET_TEMPERATURE_BY_ID = "/temperature/details";

// 4. Update temperature
export const API_UPDATE_TEMPERATURE = "/temperature/update";

// 5. Update bulk temperature
export const API_UPDATE_BULK_TEMPERATURE = "/temperature/updatebulk";

// 6. Delete temperature
export const API_DELETE_TEMPERATURE = "/temperature/delete";

// 7. Delete bulk temperature
export const API_DELETE_BULK_TEMPERATURE = "/temperature/deletebulk";

// 8. Assign user to temperature
export const API_ASSIGN_USER_TEMPERATURE = "/temperature/assignuserinbulk";
/*temperature url end */

/*oxygensaturation url start */
// 1. Create oxygensaturation
export const API_CREATE_OXYGEN_SATURATION = "/oxygensaturation/create";

// 2. Get All oxygensaturation
export const API_GET_ALL_OXYGEN_SATURATION = "/oxygensaturation/getall";

// 3. Get oxygensaturation by ID
export const API_GET_OXYGEN_SATURATION_BY_ID = "/oxygensaturation/details";

// 4. Update oxygensaturation
export const API_UPDATE_OXYGEN_SATURATION = "/oxygensaturation/update";

// 5. Update bulk oxygensaturation
export const API_UPDATE_BULK_OXYGEN_SATURATION = "/oxygensaturation/updatebulk";

// 6. Delete oxygensaturation
export const API_DELETE_OXYGEN_SATURATION = "/oxygensaturation/delete";

// 7. Delete bulk oxygensaturation
export const API_DELETE_BULK_OXYGEN_SATURATION = "/oxygensaturation/deletebulk";

// 8. Assign user to oxygensaturation
export const API_ASSIGN_USER_OXYGEN_SATURATION =
  "/oxygensaturation/assignuserinbulk";
/*oxygensaturation url end */

/*respiration url start */
// 1. Create respiration
export const API_CREATE_RESPIRATION = "/respiration/create";

// 2. Get All respiration
export const API_GET_ALL_RESPIRATION = "/respiration/getall";

// 3. Get respiration by ID
export const API_GET_RESPIRATION_BY_ID = "/respiration/details";

// 4. Update respiration
export const API_UPDATE_RESPIRATION = "/respiration/update";

// 5. Update bulk respiration
export const API_UPDATE_BULK_RESPIRATION = "/respiration/updatebulk";

// 6. Delete respiration
export const API_DELETE_RESPIRATION = "/respiration/delete";

// 7. Delete bulk respiration
export const API_DELETE_BULK_RESPIRATION = "/respiration/deletebulk";

// 8. Assign user to respiration
export const API_ASSIGN_USER_RESPIRATION = "/respiration/assignuserinbulk";
/*respiration url end */

/*height url start */
// 1. Create height
export const API_CREATE_HEIGHT = "/height/create";

// 2. Get All height
export const API_GET_ALL_HEIGHT = "/height/getall";

// 3. Get height by ID
export const API_GET_HEIGHT_BY_ID = "/height/details";

// 4. Update height
export const API_UPDATE_HEIGHT = "/height/update";

// 5. Update bulk height
export const API_UPDATE_BULK_HEIGHT = "/height/updatebulk";

// 6. Delete height
export const API_DELETE_HEIGHT = "/height/delete";

// 7. Delete bulk height
export const API_DELETE_BULK_HEIGHT = "/height/deletebulk";

// 8. Assign user to height
export const API_ASSIGN_USER_HEIGHT = "/height/assignuserinbulk";
/*height url end */

/*weight url start */
// 1. Create weight
export const API_CREATE_WEIGHT = "/weight/create";

// 2. Get All weight
export const API_GET_ALL_WEIGHT = "/weight/getall";

// 3. Get weight by ID
export const API_GET_WEIGHT_BY_ID = "/weight/details";

// 4. Update weight
export const API_UPDATE_WEIGHT = "/weight/update";

// 5. Update bulk weight
export const API_UPDATE_BULK_WEIGHT = "/weight/updatebulk";

// 6. Delete weight
export const API_DELETE_WEIGHT = "/weight/delete";

// 7. Delete bulk weight
export const API_DELETE_BULK_WEIGHT = "/weight/deletebulk";

// 8. Assign user to weight
export const API_ASSIGN_USER_WEIGHT = "/weight/assignuserinbulk";
/*weight url end */

/*headcircumference url start */
// 1. Create headcircumference
export const API_CREATE_HEAD_CIRCUMFERENCE = "/headcircumference/create";

// 2. Get All headcircumference
export const API_GET_ALL_HEAD_CIRCUMFERENCE = "/headcircumference/getall";

// 3. Get headcircumference by ID
export const API_GET_HEAD_CIRCUMFERENCE_BY_ID = "/headcircumference/details";

// 4. Update headcircumference
export const API_UPDATE_HEAD_CIRCUMFERENCE = "/headcircumference/update";

// 5. Update bulk headcircumference
export const API_UPDATE_BULK_HEAD_CIRCUMFERENCE =
  "/headcircumference/updatebulk";

// 6. Delete headcircumference
export const API_DELETE_HEAD_CIRCUMFERENCE = "/headcircumference/delete";

// 7. Delete bulk headcircumference
export const API_DELETE_BULK_HEAD_CIRCUMFERENCE =
  "/headcircumference/deletebulk";

// 8. Assign user to headcircumference
export const API_ASSIGN_USER_HEAD_CIRCUMFERENCE =
  "/headcircumference/assignuserinbulk";
/*headcircumference url end */

/*medicalcondition url start */
// 1. Create medicalcondition
export const API_ADD_MEDICAL_CONDITION = "/medicalcondition/add";

// 2. Get All medicalcondition
export const API_GET_ALL_MEDICAL_CONDITION = "/medicalcondition/getall";

// 3. Get medicalcondition by ID
export const API_GET_MEDICAL_CONDITION_BY_ID = "/medicalcondition/details";

// 4. Update medicalcondition
export const API_UPDATE_MEDICAL_CONDITION = "/medicalcondition/update";

// 5. Update bulk medicalcondition
export const API_UPDATE_BULK_MEDICAL_CONDITION = "/medicalcondition/updatebulk";

// 6. Delete medicalcondition
export const API_DELETE_MEDICAL_CONDITION = "/medicalcondition/delete";

// 7. Delete bulk medicalcondition
export const API_DELETE_BULK_MEDICAL_CONDITION = "/medicalcondition/deletebulk";

// 8. Assign user to medicalcondition
export const API_ASSIGN_USER_MEDICAL_CONDITION =
  "/medicalcondition/assignuserinbulk";

/*medicalcondition url end */

/*medicine url start */
// 1. Create medicine
export const API_ADD_MEDICINE = "/medicine/add";

// 2. Get All medicine
export const API_GET_ALL_MEDICINE = "/medicine/getall";

// 3. Get medicine by ID
export const API_GET_MEDICINE_BY_ID = "/medicine/details";

// 4. Update medicine
export const API_UPDATE_MEDICINE = "/medicine/update";

// 5. Update bulk medicine
export const API_UPDATE_BULK_MEDICINE = "/medicine/updatebulk";

// 6. Delete medicine
export const API_DELETE_MEDICINE = "/medicine/delete";

// 7. Delete bulk medicine
export const API_DELETE_BULK_MEDICINE = "/medicine/deletebulk";

// 8. Assign user to medicine
export const API_ASSIGN_USER_MEDICINE = "/medicine/assignuserinbulk";
/*medicine url end */

/**
 * Patient management url end.
 */

/* Clinical Management url start */
//get all doctor or patient
export const API_GET_USER_LIST_BY_USER = "/contact/getuserlistbyuser";

/* Clinical Management url end */

/* api docs url start */
// add new Apidoc
export const API_CREATE_API_DOC = "/apidoc/add";

// Get all list of Apidocs
export const API_GET_ALL_API_DOCS = "/apidoc/list";

// Get Apidoc details
export const API_GET_API_DOC_DETAILS = "/apidoc/details";

// Update Apidoc
export const API_UPDATE_API_DOC = "/apidoc/update";

// Delete Apidoc
export const API_DELETE_API_DOC = "/apidoc/delete";

//bulkdelete
export const API_BULK_DELETE_API_DOC = "/apidoc/bulkdelete";

//import from json file
export const API_IMPORT_API_DOC = "/apidoc/import";

//automation task schedule create bulk
export const API_BULK_CREATE_AUTOMATION_TASK_SCHEDULE =
  "/automationtaskschedule/create/bulk";

//automation task schedule create single
export const API_CREATE_AUTOMATION_TASK_SCHEDULE =
  "/automationtaskschedule/create";

//automation task schedule template bulk
export const API_BULK_CREATE_AUTOMATION_TASK_SCHEDULE_TEMPLATE =
  "/automationtaskschedule/execute/template/bulk";

//automation task schedule template
export const API_CREATE_AUTOMATION_TASK_SCHEDULE_TEMPLATE =
  "/automationtaskschedule/execute/template";

// get automation templates for select
export const API_GET_AUTOMATION_TASK_SCHEDULE_TEMPLATES =
  "/automationtaskschedule/templates";

// update automation template
export const API_UPDATE_AUTOMATION_TEMPLATE = "/automationtaskschedule/template";

// delete automation template
export const API_DELETE_AUTOMATION_TEMPLATE = "/automationtaskschedule/template";

// get automation task schedules
export const API_GET_AUTOMATION_TASK_SCHEDULES =
  "/automationtaskschedule/scheduletasks";

// get automation child tasks (subtasks where previoustask != null)
export const API_GET_AUTOMATION_CHILD_TASKS =
  "/automationtaskschedule/childtasks";

// get automation task schedule details
export const API_GET_AUTOMATION_TASK_SCHEDULE_DETAILS =
  "/automationtaskschedule/scheduletask/details";

// n8n webhook callback (used by n8n to report workflow completion)
export const API_N8N_WEBHOOK_CALLBACK =
  "/automationtaskschedule/webhook/n8n/callback";

// Proactive tasks endpoint – n8n polls this to fetch pending proactive tasks by user email
export const API_GET_PROACTIVE_TASKS = "/automationtaskschedule/proactive";

// Automation responses for a specific task
export const API_GET_AUTOMATION_RESPONSES =
  "/automationtaskschedule/automationresponse/task";

/* room url start */
//create room
export const API_CREATE_ROOM = "/room/create";

//get all rooms
export const API_GET_ALL_ROOMS = "/room/getall";

//get room details
export const API_GET_ROOM_DETAILS = "/room/details";

//update room
export const API_UPDATE_ROOM = "/room/update";

//update bulk rooms
export const API_UPDATE_BULK_ROOMS = "/room/updatebulk";

//delete room
export const API_DELETE_ROOM = "/room/delete";

//delete bulk rooms
export const API_DELETE_BULK_ROOMS = "/room/deletebulk";

//add/remove tag
export const API_ADD_REMOVE_TAG_ROOM = "/room/addremovetagroom";
/* room url end */

/* ====== Website Builder url start ====== */

// create page
export const API_CREATE_WEBSITE_PAGE = "/builder/pages";

// get all pages
export const API_GET_ALL_WEBSITE_PAGES = "/builder/pages";

// get page details
export const API_GET_WEBSITE_PAGE_DETAILS = "/builder/pages";

// update page metadata
export const API_UPDATE_WEBSITE_PAGE = "/builder/pages";

// delete page
export const API_DELETE_WEBSITE_PAGE = "/builder/pages";

// unified AI generation (chat / image upload / template)
export const API_GENERATE_WEBSITE_PAGE_CODE = "/builder/pages";

// rollback to a version
export const API_ROLLBACK_WEBSITE_PAGE_VERSION = "/builder/pages";

// publish / unpublish page
export const API_PUBLISH_WEBSITE_PAGE = "/builder/pages";

// get version history
export const API_GET_WEBSITE_PAGE_VERSIONS = "/builder/pages";

// public — no auth — get published page by companycif + slug
export const API_GET_WEBSITE_PAGE_PUBLIC = "/builder/pages/public";

// save manually edited code (WYSIWYG direct edit — no AI)
export const API_SAVE_WEBSITE_PAGE_CODE = "/builder/pages";

// section-by-section design pipeline
export const API_ANALYZE_WEBSITE_PAGE_DESIGN = "/builder/pages";
export const API_GENERATE_WEBSITE_PAGE_SECTION = "/builder/pages";

/* ====== Website Builder url end ====== */

/* ====== Telephony url start ====== */

// webhook endpoint (provider calls this — for reference / display only)
export const API_TELEPHONY_WEBHOOK = "/telephony/webhook"; // + /:provider

// initiate an outbound call
export const API_TELEPHONY_DIAL = "/telephony/dial";

// active call queue (ringing + answered)
export const API_TELEPHONY_QUEUE = "/telephony/queue";

// completed call records
export const API_TELEPHONY_RECORDS = "/telephony/records";

// save provider config (upsert)
export const API_TELEPHONY_CONFIG_SAVE = "/telephony/config";

// get provider configs for the ecosystem
export const API_TELEPHONY_CONFIG_GET = "/telephony/config";

// accept / reject a queued call — append /:callId/accept or /:callId/reject
export const API_TELEPHONY_CALL_ACCEPT = "/telephony/queue";
export const API_TELEPHONY_CALL_REJECT = "/telephony/queue";

/* ====== Telephony url end ====== */

/* ====== Webhook url start ====== */
// create webhook
export const API_CREATE_WEBHOOK = "/webhook/createwebhook";

// get all webhooks
export const API_GET_ALL_WEBHOOKS = "/webhook/getallwebhooks";

// get webhook details
export const API_GET_WEBHOOK_DETAILS = "/webhook/getwebhookdetails";

// update webhook
export const API_UPDATE_WEBHOOK = "/webhook/updatewebhook";

// delete webhook
export const API_DELETE_WEBHOOK = "/webhook/deletewebhook";
/* ====== Webhook url end ====== */

/* ====== Telephony Event url start ====== */
// get filtered event list
export const API_GET_TELEPHONY_EVENTS = "/telephonyevent/getevents";

// get single event full details
export const API_GET_TELEPHONY_EVENT_DETAILS = "/telephonyevent/geteventdetails";
/* ====== Telephony Event url end ====== */